<div class="dialog-header">
    <h1 mat-dialog-title>Audit</h1>
    <button mat-icon-button (click)="closeDialog()" class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</div>
<form #auditForm="ngForm">
    <div mat-dialog-content>
        <div>
            <mat-label class="font-bold">voucher found </mat-label>
        </div>
        <br>
        <mat-radio-group aria-label="Select an option" [(ngModel)]="audit" name="audit">
            <mat-radio-button class="ok" [value]="1">Ok</mat-radio-button>
            <mat-radio-button class="not_ok" [value]="2">Not Ok</mat-radio-button>
        </mat-radio-group>
    </div>
    <mat-form-field appearance="fill" class="w-100">
        <mat-label>Remark</mat-label>
        <input matInput name="remark" [(ngModel)]="remark" name="remark" placeholder="Enter Remark">
    </mat-form-field>
    <div mat-dialog-actions>
        <button mat-button class="btn btn-success" (click)="onSave(auditForm)">Save</button>
        <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
    </div>
</form>